import React, { useState } from "react";
import "./memoryCont.css";
import MemoryFileUploadDialog from "./fileUploadContainer/MemoryFileUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  globalMemRequest,
  listGlobalMemDocsRequest,
} from "../../../store/features/actions/memory/globalMemoryActions";
import { useUser } from "../../../context/UserContext";
import IOSSpinner from "../../HtmlElements/IOSSpinner";
import { useParams } from "react-router-dom";
import ChipSelector from "./chipSelector/ChipSelector";
import { PROJECT_DISPLAY_NAME } from "../../../config/apiConfig";

function AddToMemoryComp({ memoryType, opportunityId , selectedChips,setSelectedChips,tabConfig}) {
  const [open, setOpen] = useState(false);
  const [urlSet, setUrlSet] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [promptData, setPromptData] = useState("");
  const [webUrl, setWebUrl] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const dispatch = useDispatch();
  const { user } = useUser();
  const current_role_key = user?.role_key;
  const { globalMemDataLoading } = useSelector(
    (state) => state.globalMemDataReducer
  );

  // console.log("current_role_key",current_role_key)
  const { clientName, accountName } = useParams();

  const handleAddMemory = () => {
    const dataObj = {
      files: uploadedFiles,
      userId: user?.id,
      promptData,
      webUrl,
      fileIds: selectedFiles?.map((f) => f?._id),
      clientName,
      accountName,
      memoryType: memoryType || "opportunity",
      isAdmin:current_role_key=="CLIENT"?1:0
    };

    if (memoryType === "single-opportunity" || memoryType ==="single-contact") {
      dataObj.opportunityId = opportunityId;
    }
    if (selectedChips?.length>0) {
      dataObj.tabs=selectedChips
    }

    dispatch(globalMemRequest(dataObj));

    setPromptData("");
    setWebUrl("");
    setUploadedFiles([]);
    setSelectedFiles([]);
  };

  const handleDelete = (fileName) => {
    setUploadedFiles((prev) => prev.filter((file) => file.name !== fileName));
    setSelectedFiles((prev) =>
      prev.filter((file) => file.filename !== fileName)
    );
  };

  const handleURLInput = (e) => {
    e.preventDefault();
    setSelectedFiles([]);
    setUrlSet(true);
    setUploadedFiles([]);
  };
  const handleFileAttach = (e) => {
    e.preventDefault();
    setOpen(true);
    setUrlSet(false); 
    dispatch(listGlobalMemDocsRequest({ userId: user?.id }));
  };

  const FileItem = ({ file }) => (
    <li key={file.name} className="mem-action-file-item">
      <span className="mem-action-file-name">
        {file.name}
        <button
          onClick={() => handleDelete(file.name)}
          className="mem-action-delete-btn"
        >
          <img src="/img/xBlack.png" alt="Delete file" />
        </button>
      </span>
    </li>
  );

  return (
    <>
      <div className="add-mem-container">
        <div className="mem-titl">Add to Memory</div>
        <p className="para mem-titl-para">
          Tailor the way {PROJECT_DISPLAY_NAME} works for you. Add Instruction, Documents or
          Weblink to personalise {PROJECT_DISPLAY_NAME}
        </p>
        {memoryType === "single-opportunity" || memoryType ==="single-contact" ? (
          <>
            <ChipSelector
              items={tabConfig}
              selectedChips={selectedChips}
              setSelectedChips={setSelectedChips}
            />
          </>
        ) : null}

        <div className="mem-action-container">
          <textarea
            className="mem-action-prompt"
            placeholder="Please give a prompt"
            onChange={(e) => setPromptData(e.target.value)}
            value={promptData}
          />

          <div className="mem-action-body">
            {urlSet ? (
              <textarea
                className="mem-action-url"
                placeholder="Paste your link here"
                onChange={(e) => setWebUrl(e.target.value)}
                value={webUrl}
              />
            ) : (
              <ul className="mem-action-file-list">
                {uploadedFiles.map((file) => (
                  <FileItem key={file.name} file={file} />
                ))}
                {selectedFiles?.map((file) => (
                  <FileItem
                    key={file?.filename}
                    file={{ name: file?.filename }}
                  />
                ))}
              </ul>
            )}
          </div>

          <div className="mem-action-footer">
            <span className="mem-footer-actions">
              <img
                src="/img/UploadIcon.png"
                alt="Upload"
                onClick={(e) => {
                  handleFileAttach(e);
                }}
              />
              <img
                src="/img/AddLinkIcon.png"
                alt="Add Link"
                onClick={handleURLInput}
              />
            </span>
            <button
              className={`mem-add-btn disabled`}
              onClick={(e) => handleAddMemory(e)}
              disabled={!(promptData?.length > 5)}
            >
              {globalMemDataLoading ? (
                <IOSSpinner className="add_loader" />
              ) : (
                "Add"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ✅ Re-rendered on resetKey to ensure clean modal */}
      <MemoryFileUploadDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        uploadedFiles={uploadedFiles}
        setUploadedFiles={setUploadedFiles}
        handleDelete={handleDelete}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
      />
    </>
  );
}

export default AddToMemoryComp;
